import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { O365AuthService } from '../../../services/o365-auth.service';
import { DashboardComponent } from "../../dashboard/dashboard/dashboard.component";

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrl: './welcome-page.component.scss',
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    DashboardComponent
],
})
export class WelcomePageComponent implements OnInit {
  get signedIn(): boolean {
    return this.authService.signedIn;
  }

  get username(): string | null {
    return this.authService.username;
  }

  get userroles(): string[]   {
    return this.authService.userRoles();
  }

  constructor(private msalService: MsalService, private router: Router,
    private authService: O365AuthService) { }

  ngOnInit(): void { }


  login(): void {
    this.authService.login();
  }

}
